module.exports = __webpack_public_path__ + "static/img/ordericon1.85c90632.png";